import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "flatpickr/dist/flatpickr.css";
import { FormattedMessage, useIntl } from "react-intl";
import Loader from "components/shared/Loader";
import { addSection } from "store/actions";
import {
  EditorComponent,
  Input,
  Textarea,
} from "components/shared/FormComponents";
import AddButton from "components/shared/AddButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";

const AddService = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    // sections: categories,
    sections: departments,
    loading,
    error,
  } = useSelector((state) => state.section);
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  const [selectedIcon, setSelectedIcon] = useState({
    preview: null,
    path: "",
  });
  const [description, setDescription] = useState({ ar: "", en: "" });
  const [slider, setSlider] = useState([]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const { fields, append, remove, update } = useFieldArray({
    control,
    name: "sliders",
  });

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    // if (!selectedImage?.path) {
    //   toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
    //   return;
    // }

    data.description = description;
    // data.image = selectedImage?.path;
    // data.icon = selectedIcon?.path;
    data.title = data?.heading?.en;

    // data.startDate = getDateOfBirthWithFormat(data.startDate);
    // data.endDate = getDateOfBirthWithFormat(data.endDate);

    // if (slider?.length > 0) {
    //   data.images = slider.map((image) => {
    //     return image.path;
    //   });
    // }

    dispatch(
      addSection({ page: "services", data: { section: data }, navigate })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"addService"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={8} md={12}>
                {/* category  */}

                {/* image  */}
                {/* <Row>
                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id={"icon"} />
                      </h5>

                      <ImageUpload
                        selectedImage={selectedIcon}
                        setSelectedImage={setSelectedIcon}
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id={"image"} />
                      </h5>

                      <ImageUpload
                        selectedImage={selectedImage}
                        setSelectedImage={setSelectedImage}
                      />
                    </div>
                  </Col>
                </Row> */}

                {/*  slider */}
                {/* <Row>
                  <Col lg={12} xs={12}>
                    <div className="form-group ">
                      <h5>
                        <FormattedMessage id={"images"} />
                      </h5>
                      <ImagesUpload
                        imagesURLs={slider}
                        setImageURLs={setSlider}
                      />
                    </div>
                  </Col>
                </Row> */}
                {/* <Col>
                  <div className="form-group ">
                    <h5>
                      <FormattedMessage id="department" />
                    </h5>

                    <Controller
                      control={control}
                      name="department"
                      rules={{ required: true }}
                      render={({ field: { onChange, value, name, ref } }) => (
                        <Select
                          inputRef={ref}
                          name={name}
                          placeholder={<FormattedMessage id={"department"} />}
                          options={departments?.map((c) => ({
                            value: c?.slug,
                            label: c?.heading?.[locale],
                          }))}
                          onChange={(selectedOption) => {
                            onChange(selectedOption.value);
                          }}
                          isRtl={true}
                          isSearchable={false}
                          className="basic-single"
                          classNamePrefix="select"
                        />
                      )}
                    />
                  </div>
                </Col> */}
                {/* heading  */}
                <Row>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="title"
                      name="heading.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Input
                      langId="title"
                      name="heading.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} xs={12}>
                    <Textarea
                      name="shortDescription.ar"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                  <Col lg={6} xs={12}>
                    <Textarea
                      name="shortDescription.en"
                      register={register}
                      errors={errors}
                    />
                  </Col>
                </Row>

                {/* description  */}
                <Row>
                  <Col lg={12} xs={12}>
                    <div className="form-group ">
                      <h5>
                        <FormattedMessage id={"description"} />
                        (<FormattedMessage id={"arabic-language"} />)
                      </h5>

                      <Controller
                        control={control}
                        name="description.ar"
                        render={({ field: { value } }) => (
                          <EditorComponent
                            name="description.ar"
                            locale="ar"
                            setData={setDescription}
                          />
                        )}
                      />
                    </div>
                  </Col>

                  <Col lg={12} xs={12}>
                    <div className="form-group ">
                      <h5>
                        <FormattedMessage id={"description"} />
                        (<FormattedMessage id={"english-language"} />)
                      </h5>

                      <Controller
                        control={control}
                        name="description.en"
                        render={({ field: { value } }) => (
                          <EditorComponent
                            name="description"
                            locale="en"
                            setData={setDescription}
                          />
                        )}
                      />
                    </div>
                  </Col>
                </Row>

                {/* <FeaturesArray
                  {...{
                    register,
                    errors,
                    fields,
                    append,
                    remove,
                    update,
                  }}
                /> */}

                <AddButton />
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddService;
